const tokenTemplate = {
  access_token: null,
  refresh_token: null,
  token_type: 'bearer',
  created_at: Date.now(),
  expires_in: '3600',
  userId: null,
  deviceId: null,
  login: false,
  authorize: false,
  scope: 'public user store',
};

export const state = () => ({
  token: {},
  isRefreshing: false,
  refreshPromise: null,
});

export const getters = {
  isUserLoggedIn: state => state.token.login,
  getAccessToken: state => state.token.access_token,
  getUserId: state => state.token.userId,
  getDeviceId: state => state.token.deviceId,
  getToken: state => state.token,
};

export const mutations = {
  setToken(state, token) {
    state.token = { ...state.token, ...token };
  },
  clearToken(state) {
    state.token = { ...tokenTemplate };
  },
  setRefreshing(state, isRefreshing) {
    state.isRefreshing = isRefreshing;
  },
  setRefreshPromise(state, refreshPromise) {
    state.refreshPromise = refreshPromise;
  }
};

export const actions = {
  async requestToken({ commit }, { query }) {
    try {
      let { token } = query;
      let userId = query?.userId || null;
      let { deviceId } = query;

      if (!token) {
        const authResponse = await this.$axios.$get(`${process.env.MITRA_HOST}/_auth`, {
          withCredentials: true,
        });
        token = authResponse?.accounts?.credentials?.access_token;
        userId = authResponse?.accounts?.userData?.id;
      }
      if (!deviceId) {
        const credentialsResponse = await this.$axios.$get(`${process.env.MITRA_HOST}/api/credentials`, {
          withCredentials: true,
        });
        deviceId = credentialsResponse?.identity;
      }

      const tokenHeader = {
        access_token: token,
        created_at: Date.now(),
        userId,
        deviceId,
        login: !!userId,
        authorize: !!userId,
      };
      const data = Object.assign({}, tokenTemplate, tokenHeader);
      commit('setToken', data);
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to request token.', error);
    }
  },
  refreshToken({ commit, state }) {
    const jsBridge = window.blandroid || window.android;
    if (!jsBridge) {
      throw new Error('JS Bridge window.blandroid/window.android is not detected');
    }
    if (state.isRefreshing) {
      return state.refreshPromise;
    }
    commit('setRefreshing', true);
    let refreshPromise = null;
    refreshPromise = new Promise(resolve =>
      jsBridge.refreshToken?.(accessToken => {
        const newToken = {
          access_token: accessToken,
          created_at: Date.now(),
        };
        commit('setToken', newToken);
        commit('setRefreshing', false);
        commit('setRefreshPromise', null);
        resolve(newToken);
      })
    );
    commit('setRefreshPromise', refreshPromise);
    return refreshPromise;
  }
};
